import { META_FIELDS_LIST } from 'constants/meta';
import { get } from 'lib/API';

export const fetchMetaData = async ({ token }: any): Promise<any> => {
  const commaSeparated = META_FIELDS_LIST.join(',');
  return await get(`v2/metas?list=${commaSeparated}`, token);
};

export const fetchVendorMetaData = async (token:any) => {
  return await get(`v2/metas?list=vendors`, token);
};